import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`font-sans fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
      isHome
        ? (isScrolled ? 'bg-white/20 backdrop-blur-lg shadow-lg text-primary' : 'bg-transparent text-background')
        : 'bg-white/20 backdrop-blur-lg shadow-lg text-primary'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex-shrink-0">
            <NavLink to="/">
              <img src={`${process.env.PUBLIC_URL}/assets/logo.png`} alt="Hotel Admire Pokhara" className="h-12 w-auto" />
            </NavLink>
          </div>
          <div className="hidden lg:flex space-x-8">
            <NavLink to="/" className={({isActive}) => `transition-colors duration-300 ${isActive ? 'text-accent' : 'hover:text-accent'}`}>Home</NavLink>
            <NavLink to="/rooms" className={({isActive}) => `transition-colors duration-300 ${isActive ? 'text-accent' : 'hover:text-accent'}`}>Rooms</NavLink>
            <NavLink to="/gallery" className={({isActive}) => `transition-colors duration-300 ${isActive ? 'text-accent' : 'hover:text-accent'}`}>Gallery</NavLink>
            <NavLink to="/attractions" className={({isActive}) => `transition-colors duration-300 ${isActive ? 'text-accent' : 'hover:text-accent'}`}>Attractions</NavLink>
            <NavLink to="/about" className={({isActive}) => `transition-colors duration-300 ${isActive ? 'text-accent' : 'hover:text-accent'}`}>About</NavLink>
            <NavLink to="/contact" className={({isActive}) => `transition-colors duration-300 ${isActive ? 'text-accent' : 'hover:text-accent'}`}>Contact</NavLink>
          </div>
          <div className="lg:hidden">
            <button onClick={() => setIsOpen(!isOpen)} className="text-2xl transition-colors hover:text-accent">
              {isOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>
        {isOpen && (
          <div className="lg:hidden bg-white/20 backdrop-blur-lg shadow-lg text-primary">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <NavLink to="/" className={({isActive}) => `block px-3 py-2 rounded-md transition-colors ${isActive ? 'bg-accent text-background' : 'hover:bg-highlight'}`} onClick={() => setIsOpen(false)}>Home</NavLink>
              <NavLink to="/rooms" className={({isActive}) => `block px-3 py-2 rounded-md transition-colors ${isActive ? 'bg-accent text-background' : 'hover:bg-highlight'}`} onClick={() => setIsOpen(false)}>Rooms</NavLink>
              <NavLink to="/gallery" className={({isActive}) => `block px-3 py-2 rounded-md transition-colors ${isActive ? 'bg-accent text-background' : 'hover:bg-highlight'}`} onClick={() => setIsOpen(false)}>Gallery</NavLink>
              <NavLink to="/attractions" className={({isActive}) => `block px-3 py-2 rounded-md transition-colors ${isActive ? 'bg-accent text-background' : 'hover:bg-highlight'}`} onClick={() => setIsOpen(false)}>Attractions</NavLink>
              <NavLink to="/about" className={({isActive}) => `block px-3 py-2 rounded-md transition-colors ${isActive ? 'bg-accent text-background' : 'hover:bg-highlight'}`} onClick={() => setIsOpen(false)}>About</NavLink>
              <NavLink to="/contact" className={({isActive}) => `block px-3 py-2 rounded-md transition-colors ${isActive ? 'bg-accent text-background' : 'hover:bg-highlight'}`} onClick={() => setIsOpen(false)}>Contact</NavLink>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;